// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-ace-editor{
    position: absolute;
    width: 100%;
    height: 400px;
    border: 1px solid #ccc;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/ace-editor/ace-editor.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".softlite-ace-editor{\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 400px;\r\n    border: 1px solid #ccc;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
